var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.3036V5.94643C18.75 5.5618 18.4142 5.25 18 5.25H14.25C13.8358 5.25 13.5 5.5618 13.5 5.94643V14.3036C13.5 14.6882 13.8358 15 14.25 15H18C18.4142 15 18.75 14.6882 18.75 14.3036Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25H6C5.58579 5.25 5.25 5.56811 5.25 5.96053V18.0395C5.25 18.4319 5.58579 18.75 6 18.75H9.75C10.1642 18.75 10.5 18.4319 10.5 18.0395V5.96053C10.5 5.56811 10.1642 5.25 9.75 5.25Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/Pipeline.e827b796b03562cc4189bc3f4d9e2ec9.svg";
export { ForwardRef as ReactComponent };